import Vue from 'vue'
import Router from 'vue-router'
import common from './common/index'
import appmgmt from './appmgmt/index'
import atm from './atm/index'
import normal from './normal/index'
import purchase from './purchase/index'
import customerCare from './customerCare/index'
import warehouse from './warehouse/index'
import crtfPass from '@/views/crtfpass/CrtfPass'
import crtfPassSuc from '@/views/crtfpass/CrtfPassSuc'
import crtfPassSuc3 from '@/views/crtfpass/CrtfPassSuc3'
import crtfPassSuc4 from '@/views/crtfpass/CrtfPassSuc4'
import crtfPassSuc5 from '@/views/crtfpass/CrtfPassSuc5'
import crtfPassFail from '@/views/crtfpass/CrtfPassFail'
import crtfPassFin from '@/views/crtfpass/CrtfPassFin'
import randomNum from '@/views/crtfpass/RandomNum'
import randomNumApp from '@/views/crtfpass/RandomNumApp'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    ...appmgmt,
    ...atm,
    ...normal,
    ...common,
    ...purchase,
    ...customerCare,
    ...warehouse,
    { path: '/crtfpass/crtfPass', name: 'CrtfPass', component: crtfPass, meta: { authRequired: false, desc: 'PASS 인증'}},
    { path: '/crtfpass/crtfPassSuc', name: 'CrtfPassSuc', component: crtfPassSuc, meta: { authRequired: false, desc: 'PASS 인증성공'}},
    { path: '/crtfpass/crtfPassSuc3', name: 'CrtfPassSuc3', component: crtfPassSuc3, meta: { authRequired: false, desc: 'PASS 인증성공'}},
    { path: '/crtfpass/crtfPassSuc4', name: 'CrtfPassSuc4', component: crtfPassSuc4, meta: { authRequired: false, desc: 'PASS 인증성공'}},
    { path: '/crtfpass/crtfPassSuc5', name: 'CrtfPassSuc5', component: crtfPassSuc5, meta: { authRequired: false, desc: 'PASS 인증성공'}},
    { path: '/crtfpass/crtfPassFail', name: 'CrtfPassFail', component: crtfPassFail, meta: { authRequired: false, desc: 'PASS 인증설패'}},
    { path: '/crtfpass/crtfPassFin', name: 'CrtfPassFin', component: crtfPassFin, meta: { authRequired: false, desc: 'PASS 인증완료'}},
    { path: '/crtfpass/randomNum', name: 'RandomNum', component: randomNum, meta: { authRequired: false, desc: '난수'}},
    { path: '/crtfpass/RandomNumApp', name: 'RandomNumApp', component: randomNumApp, meta: { authRequired: false, desc: '난수app'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js